import {BaseDomainModel} from "../../../infrastructure/models/base-domain-model";
import {PositionApiModel} from "./position.api-model";

export class PositionDomainModel extends BaseDomainModel {
  apiModel: PositionApiModel;

  get name(): String {
    return this.apiModel.name;
  }

  get shortName(): String {
    return this.apiModel.shortName;
  }
}
